export const LOCAL_DEV_AUTH_TOKEN_KEY = "orcaLocalDevAuthToken";
export const LOCAL_DEV_AUTH_USER_ID_KEY = "orcaLocalDevAuthUserId";
export const LOCAL_DEV_AUTH_EMAIL_KEY = "orcaLocalDevAuthEmail";

function isLocalhost(): boolean {
	if (typeof window === "undefined") return false;
	return window.location.hostname === "localhost"
		|| window.location.hostname === "127.0.0.1"
		|| window.location.hostname === "::1";
}

function readStorageValue(key: string): string | null {
	try {
		return window.sessionStorage.getItem(key) || window.localStorage.getItem(key);
	} catch {
		return null;
	}
}

export function getLocalDevAuth() {
	if (!isLocalhost()) return null;
	const token = readStorageValue(LOCAL_DEV_AUTH_TOKEN_KEY);
	if (!token) return null;
	const id = readStorageValue(LOCAL_DEV_AUTH_USER_ID_KEY) || "local-dev-user";
	const email = readStorageValue(LOCAL_DEV_AUTH_EMAIL_KEY) || "local-dev@orca.test";
	return {
		token,
		user: {
			id,
			email,
			aud: "authenticated",
			role: "authenticated",
			user_metadata: { full_name: "Local Dev" },
		},
	};
}
